import React from 'react';
import ShopGrid from '../components/shop/ShopGrid';

export default function ShopView() {
  return <ShopGrid />;
}